import axios from "axios";

// production এ Laravel নিজেই React build serve করে (public/react), তাই
// same-origin — relative "/api/v1" ব্যবহার করলে সব জায়গায় কাজ করে।
// শুধু dev এ আলাদা করে `npm start` (port 3000) চালালে .env এ
// REACT_APP_API_URL=http://localhost:8000/api/v1 বসিয়ে override করা যায়।
const baseURL = process.env.REACT_APP_API_URL || "/api/v1";

// root (non /api/v1) endpoint লাগে শুধু CSRF cookie নেওয়ার জন্য
export const rootURL = baseURL.replace(/\/api\/v1\/?$/, "");

const api = axios.create({
  baseURL,
  headers: {
    Accept: "application/json",
  },
  // Sanctum SPA (cookie-based) auth এর জন্য session cookie + XSRF cookie
  // দুটোই request/response এ পাঠানো-নেওয়া দরকার।
  withCredentials: true,
  withXSRFToken: true,
});

// login/register/logout এর মতো POST call করার আগে অবশ্যই একবার এইটা কল
// করে নিতে হবে যাতে ব্রাউজারে XSRF-TOKEN cookie বসে (Laravel Sanctum পড়ে
// এটা VerifyCsrfToken এর জন্য)। authService.js এই ফাংশনটা ব্যবহার করে।
export const ensureCsrfCookie = () =>
  axios.get(`${rootURL}/sanctum/csrf-cookie`, { withCredentials: true });

export default api;
